import React from "react";
import { Route, Routes, useMatch } from "react-router-dom";
import DeviceAnalytics from "./views/deviceAnalytics";
import "../style.scss";
import { useAppContext } from "../../../../AppContext";

function Analytics() {
  const { user, chimeraserv, components } = useAppContext();
  const props = { user, chimeraserv, components };
  // Get the base path using useMatch
  const match = useMatch("/app/analytics/*");
  const basePath = match
    ? `/${match.pathname.split("/")[1]}`
    : "/app/analytics";

  const routes = [
    {
      name: "Device Stats",
      path: "device/list",
      component: DeviceAnalytics,
    },
  ];

  return (
    <div className="viewContainer">
      <Routes>
        <Route
          path={"device/list"}
          element={
            <DeviceAnalytics
              user={props.user}
              chimeraserv={props.chimeraserv}
              components={props.components}
            />
          }
        />
        <Route
          path="*"
          element={
            props.components.setting[0].component
              ? React.createElement(props.components.setting[0].component)
              : null
          }
        />
      </Routes>
    </div>
  );
}
export default Analytics;
